import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import FormSection from 'components/sales/formSection/formSectionNew';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import localization from 'assets/localization/localization';
import DocumentView from "../../../components/sales/downloadDocView/documentView";
import 'react-toastify/dist/ReactToastify.css';
import { Button } from 'react-bootstrap';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ModalPop from 'components/sales/modal/modal';

const InspectionCreated = ({
    match,
    inspectionCreated,
    inspectionCreatedData
}) => {
    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const roleId = localStorage.getItem('fusion-role');
    const input = {
        request_id: 0,
        user_id: 0
    }
    const [formData, setData] = useState(input);
    const [requestId, setRequestId] = useState(0);
    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await inspectionCreated(match.params.id);
            setIsLoading(false);
        })();
    }, []);


    return (
        <Layout
            title='Site Inspection Requests'
            isLoading={isLoading}
            isGoback
        >
            <FormSection title='Integration Request from Sales'>
                <div className="panel-card">
                    <div className="card-body">
                    <div className="row">
                            <div className="col-md-4">
                                <ConstantInput
                                    label='City'
                                    value={inspectionCreatedData[0]?.city_name}
                                    type="text"
                                />
                            </div>
                            <div className="col-md-4">
                                <ConstantInput
                                    label='Site Name'
                                    value={inspectionCreatedData[0]?.site_name}
                                    type="text"
                                />
                            </div>
                            <div className="col-md-4">
                                <ConstantInput
                                    label='Site Address'
                                    value={inspectionCreatedData[0]?.site_address}
                                    type="text"
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <ConstantInput
                                    label='Total Gates'
                                    value={inspectionCreatedData[0]?.total_gates}
                                    type="text"
                                />
                            </div>
                            <div className="col-md-4">
                                <ConstantInput
                                    label='POC Name'
                                    value={inspectionCreatedData[0]?.poc_name}
                                    type="text"
                                />
                            </div>
                            <div className="col-md-4">
                                <ConstantInput
                                    label='POC Number'
                                    value={inspectionCreatedData[0]?.poc_number}
                                    type="text"
                                />
                            </div>
                            
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <ConstantInput
                                    label='POC Designation'
                                    value={inspectionCreatedData[0]?.poc_designation}
                                    type="text"
                                />
                            </div>
                            <div className="col-md-4">
                                <ConstantInput
                                    label='Barrier Name'
                                    value={inspectionCreatedData[0]?.barrier_make}
                                    type="text"
                                />
                            </div>
                            <div className="col-md-4">
                                <ConstantInput
                                    label='AMC Scope'
                                    value={inspectionCreatedData[0]?.amc_scope}
                                    type="text"
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <ConstantInput
                                    label='Power Available'
                                    value={inspectionCreatedData[0]?.power_available}
                                    type="text"
                                />
                            </div>
                            <div className="col-md-4">
                                <ConstantInput
                                    label='Keys Available'
                                    value={inspectionCreatedData[0]?.keys_available}
                                    type="text"
                                />
                            </div>
                            <div className="col-md-4">
                                <ConstantInput
                                    label='Readers Make'
                                    value={inspectionCreatedData[0]?.readers_make}
                                    type="text"
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-md-6">
                                <ConstantInput
                                    label='Additional Remarks'
                                    value={inspectionCreatedData[0]?.remarks}
                                    type="text"
                                />
                            </div>
                            <div className="col-md-6">
                                <ConstantInput
                                    label='Person Assist'
                                    value={inspectionCreatedData[0]?.person_assist}
                                    type="text"
                                />
                            </div>
                        </div>
                        <div className='row'>
                            {
                               inspectionCreatedData[0]?.invoice_copy_path !== null && inspectionCreatedData[0]?.invoice_copy_path.map((path,ind) => {
                                    return (
                                        <div className="col-md-4">
                                            <DocumentView
                                                title={localization.attachment+` ${ind+1}`}
                                                attachment={path}
                                            />
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </FormSection>

        </Layout>
    );
};

export default InspectionCreated;
